import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bikeModelSelector } from 'src/redux/bike/selectors';

import { openModal } from 'src/redux/configurator/actions';

import ItemWrapper from 'components/BikeSummaryItem/BikeSummaryItem';
import Label from 'components/_utility/Label';

import { Section, Header, HeaderTitle } from './SummaryBikeCard.styled';

const SummaryBikeCard = () => {
  const modelSelector = useSelector(bikeModelSelector);
  const dispatch = useDispatch();

  return (
    <Section>
      <Header>
        <HeaderTitle>
          <Label name="bikeLabel" />
        </HeaderTitle>
      </Header>

      <ItemWrapper
        image={modelSelector.thumbnail}
        name={modelSelector.name}
        price={modelSelector.price}
        hasCTA
        ctaLabel="changeBikeLabel"
        ctaAction={() => dispatch(openModal('unsavedConfigurationAbandon'))}
      />
    </Section>
  );
};

export default SummaryBikeCard;
